#import "@/apollo/fragments/ComputedDeliverableStatus.gql"

query ComputedDeliverablesStatus(
    $campaignId: ID!
    $computedDeliverableIdentifiers: [InputComputedDeliverableIdentifier]!
) {
    computedDeliverables(campaignId: $campaignId, computedDeliverableIdentifiers: $computedDeliverableIdentifiers) {
        ...ComputedDeliverableStatus
    }
}
